<template>
    <ul>
        <li v-for="link in links" v-if="link.allow">
            <a v-if="hasUrl(link)" :href="link.url">{{ link.label}}</a><template v-else>{{ link.label }}</template>
            <sitemap-list-item v-if="hasChildren(link)" :links="link.children"></sitemap-list-item></li>
    </ul>
</template>

<script>
    export default {
        name: "sitemap-list-item",
        props: {
            links: {
                type: Array,
                required: true
            }
        },
        methods: {
            getURL: function (link) {
                return this.$globalBaseURL + link;
            },

            hasChildren: function (link) {
                return link.hasOwnProperty('children') && link.children !== [];
            },
            hasUrl: function (link)
            {
                return link.hasOwnProperty('url') && link.url !== '';
            },
        }
    }
</script>
